import store from './modules'

export default store
